import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: flex-start;
  padding: 8px 16px;
`;
export const WrapperAccordion = styled.div`
  border-radius: 4px;
  border: 1px solid #ccc;
  padding: 0 8px;
  margin-top: 8px;
  background-color:rgb(255, 255, 255);
  border-radius: 4px;
  border: 1px solid #ccc;
  padding: 0 8px;
  
  .MuiAccordionDetails-root{
    padding: 8px 0;
  }
`;